(function () {
  function initialise(root) {
    if (!root || root.dataset.avelurReady === 'true') return;
    root.dataset.avelurReady = 'true';

    root.querySelectorAll('[data-avelur-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-avelur-slider-track]');
      var previous = slider.querySelector('[data-avelur-prev]');
      var next = slider.querySelector('[data-avelur-next]');
      if (!track || !previous || !next) return;

      var timer;
      var autoplay = slider.dataset.avelurAutoplay === 'true';
      var pauseOnHover = slider.dataset.avelurPauseHover !== 'false';
      var keepAutoplayWithVideo = slider.dataset.avelurVideoAutoplay === 'true';
      var interval = Math.max(2, Number(slider.dataset.avelurAutoplaySpeed) || 3) * 1000;
      var sliderIsVisible = !('IntersectionObserver' in window);

      function initialiseSliderVisibility() {
        if (!('IntersectionObserver' in window)) return;

        var visibilityObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sliderIsVisible = entry.isIntersecting;
            if (sliderIsVisible) startAutoplay();
            else stopAutoplay();
          });
        }, { rootMargin: '300px 0px', threshold: 0.01 });

        visibilityObserver.observe(slider);
      }

      function playVideo(video) {
        if (!keepAutoplayWithVideo || document.hidden || video.dataset.avelurVisible !== 'true') return;
        var playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
      }

      function hydrateVideo(video) {
        if (video.dataset.avelurLoaded === 'true') {
          playVideo(video);
          return;
        }

        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          video.removeAttribute('data-poster');
        }

        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        video.dataset.avelurLoaded = 'true';
        video.addEventListener('loadeddata', function () {
          video.classList.add('is-loaded');
        }, { once: true });
        video.load();
        playVideo(video);
      }

      function hydrateExternalVideo(template) {
        if (!template || !template.content) return;
        template.parentNode.insertBefore(template.content.cloneNode(true), template);
        template.remove();
      }

      function initialiseLazyMedia() {
        var targets = slider.querySelectorAll('[data-avelur-lazy-video], [data-avelur-lazy-external-video]');
        if (!targets.length) return;

        if (!('IntersectionObserver' in window)) {
          targets.forEach(function (target) {
            if (target.matches('[data-avelur-lazy-video]')) {
              target.dataset.avelurVisible = 'true';
              hydrateVideo(target);
            } else {
              hydrateExternalVideo(target);
            }
          });
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var target = entry.target;
            if (target.matches('[data-avelur-lazy-video]')) {
              target.dataset.avelurVisible = entry.isIntersecting ? 'true' : 'false';
              if (entry.isIntersecting) hydrateVideo(target);
              else if (target.dataset.avelurLoaded === 'true') target.pause();
            } else if (entry.isIntersecting) {
              hydrateExternalVideo(target);
              observer.unobserve(target);
            }
          });
        }, { rootMargin: '300px 160px', threshold: 0.01 });

        targets.forEach(function (target) { observer.observe(target); });
      }

      function stepSize() {
        var firstItem = track.firstElementChild;
        if (!firstItem) return track.clientWidth * 0.86;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        return firstItem.getBoundingClientRect().width + gap;
      }

      function move(direction) {
        var step = stepSize();
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - step * 0.5;
        if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      function stopAutoplay() {
        if (timer) window.clearInterval(timer);
        timer = undefined;
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay || !sliderIsVisible || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(function () { move(1); }, interval);
      }

      previous.addEventListener('click', function () {
        move(-1);
        startAutoplay();
      });
      next.addEventListener('click', function () {
        move(1);
        startAutoplay();
      });

      if (pauseOnHover) {
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin', stopAutoplay);
        slider.addEventListener('focusout', startAutoplay);
      }

      slider.querySelectorAll('video').forEach(function (video) {
        if (keepAutoplayWithVideo) {
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('controlslist', 'nofullscreen nodownload noremoteplayback');
          video.setAttribute('disablepictureinpicture', '');
          video.setAttribute('disableremoteplayback', '');
        } else {
          video.addEventListener('play', stopAutoplay);
          video.addEventListener('pause', startAutoplay);
          video.addEventListener('ended', startAutoplay);
        }
      });

      initialiseLazyMedia();
      initialiseSliderVisibility();

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
          slider.querySelectorAll('video[data-avelur-loaded="true"]').forEach(function (video) { video.pause(); });
        } else {
          startAutoplay();
          slider.querySelectorAll('video[data-avelur-visible="true"]').forEach(playVideo);
        }
      });

      startAutoplay();
    });

    root.querySelectorAll('[data-avelur-scroll-product]').forEach(function (button) {
      button.addEventListener('click', function () {
        var product = document.querySelector('[id^="MainProduct-"]') || document.querySelector('[id^="ProductInfo-"]') || document.querySelector('product-info');
        if (product) product.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll('[data-avelur-story]').forEach(initialise);
    initialiseBundlePreviews(scope || document);
  }

  function imageUrlWithWidth(url, width) {
    if (!url) return '';
    var normalized = url.indexOf('//') === 0 ? 'https:' + url : url;
    return normalized + (normalized.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function initialiseBundlePreviews(scope) {
    scope.querySelectorAll('quantity-breaks').forEach(function (bundle) {
      if (bundle.dataset.avelurPreviewsReady === 'true') return;

      var dataNode = bundle.querySelector('[data-avelur-bundle-variants]');
      if (!dataNode) return;

      var variants = [];
      try { variants = JSON.parse(dataNode.textContent); } catch (error) { return; }

      function refresh(select) {
        var row = select.closest('.quantity-break__selector-item');
        if (!row) return;

        var selectedOptions = Array.prototype.map.call(
          row.querySelectorAll('.quantity-break__variant-select'),
          function (picker) { return picker.value; }
        );
        var variant = variants.find(function (candidate) {
          return candidate.options && candidate.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        });
        var image = row.querySelector('[data-avelur-bundle-variant-image]');
        if (!variant || !image) return;

        var source = variant.featured_image && variant.featured_image.src;
        if (!source && variant.featured_media && variant.featured_media.preview_image) {
          source = variant.featured_media.preview_image.src;
        }
        if (source) image.src = imageUrlWithWidth(source, 120);
      }

      bundle.querySelectorAll('.quantity-break__variant-select').forEach(function (select) {
        select.addEventListener('change', function () { refresh(select); });
        refresh(select);
      });
      bundle.dataset.avelurPreviewsReady = 'true';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  else initialiseAll(document);

  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
